document.addEventListener('DOMContentLoaded', function () {
  const totalAthleteBlocks = document.querySelectorAll('.pm-8153-athletes-item').length;
  const swiperWrapper = document.querySelector('.swiper-container');

  const isLargeScreen = () => window.innerWidth >= 1024;
  const shouldInitSlider = () => !isLargeScreen() || totalAthleteBlocks >= 4;

  let mySwiper;

  function initSwiper() {
    if (!shouldInitSlider()) return;

    mySwiper = new Swiper('.swiper-container', {
      loop: false,
      grabCursor: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        0: {
          slidesPerView: 1.1,
          spaceBetween: 8,
        },
        600: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3.2,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
      on: {
        init: function () {
          this.emit('breakpoint');
        },
        breakpoint: function () {
          const navNext = document.querySelector('.swiper-button-next');
          const navPrev = document.querySelector('.swiper-button-prev');
          const paginationEl = document.querySelector('.swiper-pagination');

          const showNav = totalAthleteBlocks >= 4 && isLargeScreen();
          if (navNext) navNext.style.display = showNav ? 'flex' : 'none';
          if (navPrev) navPrev.style.display = showNav ? 'flex' : 'none';
          if (paginationEl) paginationEl.style.display = 'block';
        },
      },
    });
  }

  function destroySwiper() {
    if (mySwiper) {
      mySwiper.destroy(true, true);
      mySwiper = null;
    }
  }

  function handleResize() {
    if (shouldInitSlider()) {
      if (!mySwiper) initSwiper();
    } else {
      destroySwiper();
    }
  }

  handleResize();
  window.addEventListener('resize', handleResize);
});
